import { useEffect } from "react";
import { useLocation } from "react-router";
import { useLanguage } from "../Services/ContextProvider/LanguageContextProvider";

function PageNotFound() {
    const location = useLocation();
    const { t } = useLanguage();

    useEffect(() => {
        if (location.pathname !== '/chat') {
            sessionStorage.removeItem("persist_session");
        }
    }, [location]);

    return (
        <div className=" d-flex justify-content-center align-items-center pagenotfound">
            <h1>
                {t('NO Page Found')}
            </h1>
        </div>
    );
}

export default PageNotFound;